module.exports = __webpack_public_path__ + "img/示例图_1.c8b0e68d.png";